<template lang="pug">
#service_host_limit_callacout_wrapper
  .callout.callout-info
    h5 Freeプランのため「{{host_name}}」の登録ができません。
    p 設置URLで設定中のドメインと違うために登録ができません。有料プランではドメイン関係なく登録が可能です。
    a.btn.btn-secondary.mr-3(:href="host_setting_url") 設定URLを変更
    a.btn.btn-primary(:href="plan_page_url") プランをアップグレード
</template>

<script>

export default {
  props: {
    plan_page_url: String,
    host_setting_url: String,
    host_name: String,
  },
}
</script>
<style lang="scss" scoped>
</style>
